import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Reveal } from './Reveal';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-36" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-37" data-mp="1nwmetz0a1iw7">
        <div className="mb-12 text-center" data-id="element-38" data-mp="2blf2l86qwkfq">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-coral" data-id="element-39" data-mp="2bmgok7paurc8">WARTO WIEDZIEĆ</p>
          <h2 className="text-3xl font-black uppercase tracking-tight text-brand-navy md:text-4xl" data-id="element-40" data-mp="2fns8pxpemkd1">
            Najczęściej zadawane pytania
          </h2>
        </div>
        <div className="space-y-3" data-id="element-41" data-mp="26s2q1wfcc43c">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-navy/[0.06] bg-brand-alt" data-id="element-42" data-mp="2zb9g7ryw2d11" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold text-brand-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-coral" data-id="element-43" data-mp="1vnetgl53eg9v">
                  <span data-id="element-44" data-mp="2adm7moo2hd4r">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-coral" aria-hidden="true" data-id="element-45" data-mp="2oeyk2q40qwlw" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-coral" aria-hidden="true" data-id="element-46" data-mp="2jgeyiqtc7mu2" />}
                </button>
                <AnimatePresence initial={false} data-id="element-47" data-mp="u2i6f48w8g70">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-48" data-mp="p2vv50cmla0u">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-49" data-mp="3344rtq3ijhdb">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}